import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import { taskManagerContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";

const RefundTask = () => {

  const { account } = useWeb3React();
  const web3 = useWeb3();
  const tokenAddress = Environment.tastManager;
  const contract = taskManagerContract(tokenAddress, web3);


  const refundTask = useCallback(
    async (creater, taskId, sign) => {
      // console.log(creater?.signedKeyDetails?.deadline, taskId, "redeemTask payload 3");

      try {
        const gas = await contract.methods.processTaskAction(taskId, 1, creater?.signedKeyDetails?.deadline, sign, sign).estimateGas({
          from: account
        });
        const details = await contract.methods.processTaskAction(taskId, 1, creater?.signedKeyDetails?.deadline, sign, sign).send({
          from: account,
          gas,
        });
        return details;
      } catch (error) {
        console.log(error, 'error');

        throw error;
      }
    },
    [contract, account]
  );
  return { refundTask: refundTask };
};
export default RefundTask;